/** Capacity failures, offline clients and timeouts do not revoke a session. */
export function isCredentialRefreshFailure(error: unknown): boolean {
  const status = (error as { response?: { status?: number } } | null)?.response?.status
  return status === 400 || status === 401 || status === 403
}
